"use strict";

angular.module("vendor")
.component("partnershipForm", {
    templateUrl: require("./partnership-form.component.html"),
    controller: PartnershipFormController,
    controllerAs: "partnershipFormCtrl"
});

function PartnershipFormController(
    $scope, $rootScope, $state, $stateParams, $q, $timeout, gettextCatalog, Language, PartnershipService, FormError,
    ModalService, PatternService, DepartmentService, UserService, PaymentService, Workflow, common, moment, FlashBag,
    ActionFactory, CustomerFinancialService, EMAIL_MAXLENGTH, PRODUCT_ACQUISITION_METHOD,
    PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES
) {
    var _this = this;
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    Language.initializeScope($scope, "language", "locale");
    $scope.languages = $rootScope.languages;
    $scope.pattern = PatternService;
    $scope.partnershipService = PartnershipService;
    $scope.methodChoicesLocalized = [];
    $scope.preAuthorizedMethodChoicesLocalized = [];
    $scope.hasUnsavedPartnershipChanges = false;
    $scope.hasUnsavedRuleChanges = false;
    $scope.agreementTypes = CustomerFinancialService.getPreAuthorizedPaymentAgreementTypeTranslations();
    $scope.PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES = PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES;
    $scope.Partnership = {
        allows_ordering_over_credit_limit: true,
        allows_ordering_with_overdue_invoice: true,
        use_vendor_allowed_payment_methods: true,
        use_vendor_allowed_pre_authorized_payment_methods: true,
        use_vendor_pre_authorized_payment_agreement_type: true,
        product_acquisition_method: PRODUCT_ACQUISITION_METHOD['DELIVERY'],
        total_unpaid_amount: 0,
        allowed_payment_methods: [],
        allowed_pre_authorized_payment_methods: []
    };
    $scope.departmentValues = {};

    $scope.$watch("partnershipForm.$dirty", function(newValue) {
        $scope.hasUnsavedPartnershipChanges = newValue;
    });

    $scope.$watch("rulesForm.$dirty", function(newValue) {
        $scope.hasUnsavedRuleChanges = newValue;
    });

    $scope.recurrenceStartDateOptions = {
        useCurrent: false,
        allowInputToggle: true,
        locale: $scope.locale,
        format: "YYYY-MM-DD",
        toolbarPlacement: "bottom",
        showClose: true,
        icons: {
            close: "fa fa-check"
        }
    };
    $scope.newRule = {recurrence_interval: 1};
    $scope.orderThresholdTimeOptions = {
        useCurrent: true,
        allowInputToggle: true,
        format: "hh:mm a",
        stepping: 15,
        toolbarPlacement: "bottom",
        showClose: true,
        icons: {
            close: "fa fa-check"
        }
    };
    $scope.workflows = [
        {section: "catalogEdit"},
        {section: "salesRepresentativesEdit"}
    ];

    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        setWeekdays(locale);
    });

    $scope.PRODUCT_ACQUISITION_METHOD = PRODUCT_ACQUISITION_METHOD;

    UserService.isUserFetched().then(function onSuccess(user) {
        $scope.user = user;
        if (user && user.info) {
            $scope.defaultLanguage = user.info.Language;
            $scope.defaultTimeZone = user.info.timezone;
        }
        if (user && user.vendor) {
            $scope.allowCustomersManagement = user.vendor.allow_customers_management;
            if (!$stateParams.id) {
                $scope.Partnership.allows_ordering_over_credit_limit = user.vendor.default_partnership_ordering_over_credit_limit_value;
                $scope.Partnership.allows_ordering_with_overdue_invoice = user.vendor.default_partnership_ordering_with_overdue_invoice_value;
                $scope.Partnership.vendor_pre_authorized_payment_agreement_type = user.vendor.pre_authorized_payment_agreement_type;
            }
        }
    });

    this.setDeliveryDay = function(rule, $index) {
        rule.weekday = null;
        var ruleElement = $scope.rulesForm['recurrenceStartDate' + $index];
        ruleElement.$setValidity("weekdayUsed", true);
        ruleElement.$setValidity("dateUsed", true);
        ruleElement.$setValidity("pastDate", true);
        if (
            rule.recurrence_start_date && rule.recurrence_interval === 0
            && moment(rule.recurrence_start_date).startOf('day').isBefore(moment().startOf('day'), 'day')
        ) {
            ruleElement.$setValidity("pastDate", false);
        }
        else if (rule.recurrence_start_date && rule.recurrence_start_date._isValid) {
            var ruleWeekday = moment(rule.recurrence_start_date).isoWeekday();
            angular.forEach($scope.Partnership.delivery_rules, function(value, key) {
                if (
                    key !== $index && value.recurrence_interval === 1 && value.recurrence_interval === rule.recurrence_interval
                    && value.weekday === ruleWeekday
                ) {
                    ruleElement.$setValidity("weekdayUsed", false);
                    ruleWeekday = null;
                }
                else if (
                    key !== $index && value.recurrence_interval === 0 && value.recurrence_interval === rule.recurrence_interval
                    && moment(value.recurrence_start_date).startOf('day').isSame(moment(rule.recurrence_start_date).startOf('day'), 'day')
                ) {
                    ruleElement.$setValidity("dateUsed", false);
                    ruleWeekday = null;
                }
            });
            rule.weekday = ruleWeekday;
        }
    };

    this.fetchTags = function(query) {
        return $scope.partnershipService.queryTags(query);
    };

    this.deleteDeliveryRule = function(item) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "selector",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Delivery Rule"),
                    message: gettextCatalog.getString("Do you really want to delete this rule?")
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result) {
                    var index = $scope.Partnership.delivery_rules.indexOf(item);
                    $scope.Partnership.delivery_rules.splice(index, 1);
                    $scope.hasUnsavedRuleChanges = true;
                }
            });
        });
    };

    this.removeDeliveryRule = function(item) {
        var index = $scope.Partnership.delivery_rules.indexOf(item);
        $scope.Partnership.delivery_rules.splice(index, 1);
        $scope.hasUnsavedRuleChanges = true;
    };

    this.addDeliveryRule = function() {
        if (!$scope.Partnership.delivery_rules) {
            $scope.Partnership.delivery_rules = [];
        }
        $scope.Partnership.delivery_rules.push({
            weekday: "",
            threshold_local_weekday: "",
            threshold_local_time: "",
            timezone: $rootScope.user.info.timezone,
            recurrence_start_date: "",
            recurrence_interval: 1,
            enabled: true
        });
        $scope.hasUnsavedRuleChanges = true;
    };

    this.approve = function() {
        $scope.Partnership.approval_status = "approved";
        this.savePartnership().then(function onSuccess() {
            FlashBag.success(gettextCatalog.getString("Customer request was approved."), true);
            window.history.back();
        });
    };

    this.reject = function() {
        $scope.Partnership.approval_status = "rejected";
        this.savePartnership().then(function onSuccess() {
            FlashBag.success(gettextCatalog.getString("Customer request was rejected."), true);
            window.history.back();
        });
    };

    this.allowCreateManager = function(status) {
        return PartnershipService.isStatusValidForManagerCreation(status);
    };

    this.createUserCustomerManager = function() {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("../modals/create-user-customer-manager.modal.html"),
            controller: "CreateUserCustomerController",
            controllerAs: "createUserCustomerCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Create Manager"),
                    partnershipId: $stateParams.id,
                    defaultLanguage: $scope.defaultLanguage,
                    defaultTimeZone: $scope.defaultTimeZone
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result) {
                    fetch();
                }
            });
        });
    };

    this.reSendUserCustomerManagerInvitation = function(userCustomerId) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Resend Manager Invitation"),
                    message: gettextCatalog.getString("Do you want resend an invitation to the manager?")
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result) {
                    PartnershipService.reSendManagerInvitation($stateParams.id, userCustomerId).then(
                        function onSuccess() {
                            FlashBag.success(gettextCatalog.getString("The invitation to the manager was sent successfully."), true);
                            fetch();
                        },
                        function onError(response) {
                            FlashBag.apiError(response);
                        }
                    );
                }
            });
        });
    };

    this.savePartnership = function() {
        var deferred = $q.defer();
        $scope.partnershipForm.$setSubmitted();
        FlashBag.clearAll();

        if (
            (
                $scope.partnershipForm.$valid && $scope.rulesForm.$valid
                && $scope.paymentTermsForm.$valid && $scope.billingForm.$valid
            ) || $scope.partnershipForm.buyer_number.$error.used
        ) {
            var partnership_copy = angular.copy($scope.Partnership);

            angular.forEach(partnership_copy.delivery_rules, function(value, key) {
                partnership_copy.delivery_rules[key].threshold_local_time = moment(value.threshold_local_time).format("HH:mm:ss");
                partnership_copy.delivery_rules[key].recurrence_start_date = moment(value.recurrence_start_date).hours(0).minutes(0).seconds(0);
            });

            var promise;
            if ($stateParams.id) {
                promise = $scope.partnershipService.update(partnership_copy);
            }
            else {
                promise = $scope.partnershipService.add(partnership_copy);
            }

            promise.then(
                function onSuccess(data) {
                    $scope.hasUnsavedPartnershipChanges = false;
                    $scope.hasUnsavedRuleChanges = false;
                    $scope.partnershipForm.$setPristine();
                    $scope.rulesForm.$setPristine();
                    $scope.partnershipForm.buyer_number.$setValidity("used", true);
                    if (data.invitation_sent) {
                        FlashBag.success(gettextCatalog.getString("Reminder was sent to the new email address."), true);
                    }
                    return $timeout(function() {
                        deferred.resolve(data);
                    });
                },
                function onError(response) {
                    if (response && response.data && response.data.candidate_customers) {
                        openCandidateCustomersModal(response.data.candidate_customers, $scope.Partnership.email).then(
                            deferred.resolve,
                            deferred.reject
                        );
                        return;
                    }
                    var is_buyer_number_used = !response.data["buyer_number"];
                    $scope.partnershipForm.buyer_number.$setValidity("used", is_buyer_number_used);
                    delete $scope.Partnership.selected_customer_id;
                    delete $scope.Partnership.create_prospect;
                    FormError.focus("partnershipForm");
                    FlashBag.apiError(response);
                    deferred.reject(response);
                });
        }
        else {
            if (!$scope.partnershipForm.$valid) {
                FormError.focus("partnershipForm");
            }
            else if (!$scope.rulesForm.$valid) {
                FormError.focus("rulesForm");
            }
            else if (!$scope.paymentTermsForm.$valid) {
                FormError.focus("paymentTermsForm");
            }
            else if (!$scope.billingForm.$valid) {
                FormError.focus("billingForm");
            }
            deferred.reject(true);
        }
        return deferred.promise;
    };

    function openCandidateCustomersModal(candidateCustomers, email) {
        var deferred = $q.defer();
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("./partnership-candidate-customers.modal.html"),
            controller: "PartnershipCandidateCustomersController",
            controllerAs: "candidateCustomersCtrl",
            inputs: {
                $attrs: {
                    candidateCustomers: candidateCustomers,
                    email: email
                }
            }
        }).then(function(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result) {
                    if (result === "new") {
                        $scope.Partnership.create_prospect = true;
                    }
                    else {
                        $scope.Partnership.selected_customer_id = result;
                    }
                    _this.savePartnership().then(
                        deferred.resolve,
                        deferred.reject
                    );
                }
                else {
                    deferred.reject();
                }
            });
        });
        return deferred.promise;
    }

    function fetch() {
        $scope.PartnershipId = $stateParams.id;
        if (!$scope.PartnershipId) {
            return;
        }

        $scope.addDeliveryRules = false;
        $scope.partnershipService.get($scope.PartnershipId).$promise.then(
            function(data) {
                $scope.Partnership = data;
                angular.forEach($scope.Partnership.delivery_rules, function(value, key) {
                    var times = value.threshold_local_time.split(":");
                    $scope.Partnership.delivery_rules[key].threshold_local_time = moment().hours(times[0]).minutes(times[1]).seconds(times[2]);
                    $scope.Partnership.delivery_rules[key].recurrence_start_date = moment(value.recurrence_start_date);
                });
                $timeout(function() {
                    $scope.rulesForm.$setPristine();
                });
                getDepartmentValues();
            }
        );
    }

    function getDepartmentValues() {
        DepartmentService.query().$promise.then(function onSuccess(departments) {
            angular.forEach(departments, function(value, key) {
                $scope.departmentValues[parseInt(value.id)] = value.name;
            });
        });
    }

    this.sendPaymentReminder = function() {
        var actionService = new ActionFactory(CustomerFinancialService);
        actionService.submitSingleAction(
            "send_financial_reminder",
            $scope.Partnership.id
        );
    };

    this.goToOverdueInvoices = function() {
        var endOfYesterday = moment().subtract(1, 'days').endOf('day').toISOString()
        var invoiceFilters = {
            'payment_due_date_end': endOfYesterday,
            'status': 'partially_paid,transmitted',
            'customer_ids': $scope.Partnership.buyer.id
        };
        $state.go("invoiceList", invoiceFilters);
    }

    this.goToUnpaidInvoices = function() {
        var invoiceFilters = {
            'status': 'partially_paid,transmitted',
            'customer_ids': $scope.Partnership.buyer.id
        };
        $state.go("invoiceList", invoiceFilters);
    }

    function setWeekdays(locale) {
        $scope.weekdays = common.getISOWeekdays(locale);
    }

    PaymentService.getVendorAllowedPaymentMethodChoicesLocalized()
    .then(function onSuccess(response) {
        $scope.methodChoicesLocalized = response.data;
    });

    PaymentService.getVendorAllowedPreAuthorizedPaymentMethodChoicesLocalized()
    .then(function onSuccess(response) {
        $scope.preAuthorizedMethodChoicesLocalized = response.data;
    });

    setWeekdays($scope.locale);

    $scope.$on("LanguagesFetched", function(evt, languages) {
        $scope.languages = languages;
    });

    fetch();

}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/partnership-form/partnership-form.component.js
// module id = 970
// module chunks = 0